import { Avatar } from "mds/components/Avatar";
import { useAppSelector } from "store/index";
import { userSelectors } from "store/selectors";
import { getUserInitials } from "utils/user-utils";
import { getUserColor } from "worksheets/helpers/colors";

export const SectionUserAvatar = ({ userId }: { userId: string }) => {
  const user = useAppSelector((s) => userSelectors.selectById(s, userId));
  const color = getUserColor(userId);

  return (
    <Avatar bgColor={color} className="text-white">
      {getUserInitials(user)}
    </Avatar>
  );
};
